<style scoped lang="less">
  .floor4-wrapper{
    width: 100%;
    height: 100%;
    .w{
      width: 100%;
    }
  }
  .swiper-content {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    padding: 50px 0 100px;

    .show-swiper {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      .swiper-slide {
        width: 100%;
        height: 767px;
        overflow: hidden;
        // 表示所有属性都有动作效果，过度时间为0.4s，以慢速开始和结束的过渡效果
        transition: all .4s cubic-bezier(.4, 0, .2, 1);

        .swiper-item img{
          width: 100%;
          height: 767px;
        }
      }
    }
  }
  .swiper-button-gray{
    background: url('https://img.gegejia.com/img/3261467f7c58babf088ae673412ccae6.png') no-repeat  !important;
    background-size: contain !important;
  }
  .swiper-button-gray2{
    background: url('https://img.gegejia.com/img/51b27ea0c3bf73a6dcff268af1c4bd42.png') no-repeat  !important;
    background-size: contain !important;
  }
  .local_list{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px 0 200px;
    .img{
      width: 342px;
      height: 342px;
      margin:0 36px;
      cursor: pointer;
      position: relative;
      img{
        width: 342px;
        height: 342px;
      }
      .t{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background: rgba(0,0,0,0.6);
        color: #fff;
        text-align: center;
        font-size:18px;
        line-height: 40px;
      }
    }
  }
</style>
<template>
  <div class="floor4-wrapper">
    <div class="swiper-content">
      <swiper ref="mySwiper4" :options="swiperOption" class="show-swiper">
        <template v-for="(item, index) in list">
          <swiper-slide :key="index">
            <div class="swiper-item">
              <img :src="item" alt="">
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-button-prev swiper-button-gray" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-gray2" slot="button-next"></div>
      </swiper>
    </div>
    <div class="local_list">
      <div class="img"  @click="localC(0)">
        <img src="https://img.gegejia.com/img/f7d49c123099215050d3150c9fc660e6.png" alt="">
        <div class="t">T97 COFFEE 杭州湖滨in77旗舰店</div>
      </div>
      <div class="img"  @click="localC(1)">
        <img src="https://img.gegejia.com/img/49eb301b6a8fac69f43fef14848a9c7f.png" alt="">
        <div class="t">T97 COFFEE 杭州聚光中心门店</div>
      </div>
      <div class="img"  @click="localC(2)">
        <img src="https://img.gegejia.com/img/0c721944b1c4d152ee73381ee9936a5c.png" alt="">
        <div class="t">T97 COFFEE 广州市敏捷广场门店</div>
      </div>
    </div>
  </div>
</template>

<script>

  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import("swiper/dist/css/swiper.css");
  export default {
    data() {
      var that = this
      return {
        totalList: [
          [
            'https://img.gegejia.com/img/f1aaed70e433de76f814e364e0ea2255.png',
            'https://img.gegejia.com/img/06976ffc1d6950dd53260cc76da5428b.png'
          ],
          [
            'https://img.gegejia.com/img/72a90e8eb27c64db37d05279c2f0b931.png',
            'https://img.gegejia.com/img/59d958eee40a5096811a001d45493410.png',
            'https://img.gegejia.com/img/4dd85aa8bb47de95046377b2c910bdda.png'
          ],
          [
            'https://img.gegejia.com/img/a237002433b524f10d437a98003d0f1d.png',
            'https://img.gegejia.com/img/88112fee447445ca366f1db7eabc9fc1.png',
            'https://img.gegejia.com/img/396c5a85dd728e4dd1ee1c67a4fbf55f.png'
          ]
        ],
        list: [],
        activeIndex: 1,
        swiperOption: {
          // 设置slider容器能够同时显示的slides数量，默认为1， 'auto'则自动根据slides的宽度来设定数量
          slidesPerView: 'auto',
          initialSlide:0,
          spaceBetween: 0,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          loop: true,
          loopAdditionalSlides: 2,
          /*
          * 开启这个参数来计算每个slide的progress(进度、进程)
          * 对于slide的progress属性，活动的那个为0，其他的依次减1
          */
          watchSlidesProgress: true,
          // 默认active slide居左，设置为true后居中
          // 当你创建一个Swiper实例时是否立即初始化，这里我们手动初始化
          init: true,
          longSwipesRatio: 0.1,
          touchReleaseOnEdges: true,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    components: {
      swiper,
      swiperSlide,
    },
    mounted() {
      this.list = this.totalList[0]
    },
    methods: {
      localC(n) {
        this.list = this.totalList[n]
        this.$refs.mySwiper4.update()
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/t97/block/floor_4.vue